module.exports = __webpack_public_path__ + "static/media/mouse.ccaed28a.svg";